<div class="create-dialog-box scrollable-dialog container">
    <!-- Popup Header -->
    <div class="title d-flex align-items-center justify-content-space-between">
        <h4 class="mb-0">Transcript</h4>
        <button
            class="close-btn bg-transparent p-0 border-none"
            (click)="close()"
        >
            <i class="flaticon-close"></i>
        </button>
    </div>
    <div class="mt-3" style="max-height: 80vh; overflow-y: auto;">
        <div mat-dialog-content>
            <p [innerHTML]="sanitizedData"></p>
        </div>
    </div>
</div>
